import React, { Fragment, h } from "preact";
import { AppPage } from "../_common/components/app-page";
import { Card, CF, R } from "../_common/layout";
import { t } from "../_i18n";
import { useHistory } from "react-router";
import { connect } from "react-redux";
import { useEffect, useState, useMemo, useRef } from "preact/hooks";
import { Form as FinalForm } from "react-final-form";
import {
  Select,
  UploadFile,
  FormFieldSplittedDate,
} from "../_common/forms/components/components";
import ButtonSpinner from "../_common/components/buttons/buttonSpinner/buttonSpinner";
import { ButtonGhost, ButtonPrimary } from "../_common/components/buttons/buttons";
import Badge from "../_common/components/Badge";
import Spinner from "../_common/components/Spinner";
import Modal from "../_common/components/Modal";
import {
  getCertApplicationStatus,
  getAceCertApplicationStatus,
  uploadCertPaymentReceipt,
  uploadAceCertPaymentReceipt,
  generateVoucher,
} from "../_rx/certificate-application/actions";
import {
    fetchExpedientAcademicProgram,
} from "../_rx/expediente/actions"
import { ModalFinishedAPCertificate } from "../expediente/components/modalFinishedAPCertificate";

const STATUS_PENDING_APPLICATION = 1;
const STATUS_VALIDATED = 2;
const STATUS_UPLOADED_GITU = 3;
const STATUS_VALIDATED_INSPECTION = 4;
const STATUS_REJECTED = 5;
const STAUTS_UNDEFINED = 0;

const statusBadgeTextDic = {
  [STATUS_PENDING_APPLICATION]: t("certificate_status_pending"),
  [STATUS_UPLOADED_GITU]: t("certificate_status_validated"),
  [STATUS_VALIDATED_INSPECTION]: t("certificate_status_validated"),
  [STATUS_VALIDATED]: t("certificate_status_validated"),
  [STATUS_REJECTED]: t("certificate_status_rejected"),
};

const statusBadgeClassDic = {
  [STATUS_PENDING_APPLICATION]: "badge-warning",
  [STATUS_UPLOADED_GITU]: "badge-success translucent",
  [STATUS_VALIDATED_INSPECTION]: "badge-success translucent",
  [STATUS_VALIDATED]: "badge-success translucent",
  [STATUS_REJECTED]: "badge-danger",
};

const bonosOptionsList = [
  {
    name: t("certificate_voucher_free"),
    key: "free",
  },
  {
    name: t("certificate_voucher_general"),
    key: "general_voucher",
  },
  {
    name: t("certificate_voucher_friend"),
    key: "new_student_voucher",
  },
];

const BadgeComponent = ({ status, extraClass }) => (
  <Badge
    className={`t-upper width-fit-content badge font-small ${extraClass || ""} ${statusBadgeClassDic[status] || "d-none"}`}
  >
    {t(statusBadgeTextDic[status])}
  </Badge>
);

function CertificateApplication({
  studentId,
  finishedAcademicPrograms,
  getCertApplicationStatus,
  getAceCertApplicationStatus,
  certificateApplicationStatus,
  aceCertificateApplicationStatus,
  uploadCertPaymentReceipt,
  uploadAceCertPaymentReceipt,
  generateVoucher,
  fetchExpedientAcademicProgram,
}) {
  /** Variables **/
  const formRef = useRef(null);
  const academicPrograms = finishedAcademicPrograms
    ?.filter(
      (ap) =>
        (ap.formative_zone === "MAD" || ap.formative_zone === "CAT") && ap.closed_academic_record,
    )
    .map((ap) => ({
      name: ap.title + " " + `(${ap.formative_zone_code})`,
      key: ap.id,
    }));
  const showMultipleCicles = academicPrograms.length > 1;

  /** States **/
  const [academicProgramId, setAcademicProgramId] = useState(academicPrograms[0]?.key);
  const [aceFile, setAceFile] = useState(null);
  const [aceFileURL, setAceFileURL] = useState("#");
  const [aportaEmpresa, setAaportaEmpresa] = useState(false);
  const [bonoEnviado, setBonoEnviado] = useState(false);
  const [bonoGenerado, setBonoGenerado] = useState(false);
  const [bonoId, setBonoId] = useState(bonosOptionsList[0].key);
  const [cartUrl, setCartUrl] = useState(null);
  const [file, setFile] = useState(null);
  const [fileURL, setFileURL] = useState("#");
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [openBonoModal, setOpenBonoModal] = useState(false);
  const [openBonoConfirmModal, setOpenBonoConfirmModal] = useState(false);
  const [pagado, setPagado] = useState(null);
  const [selectedExpedientAcademicProgram, setSelectedExpedientAcademicProgram] = useState(null);
  const [modalAPFinishedVisible, setModalAPFinishedVisible] = useState(false);

  /** Memos **/
  const selectedAP = useMemo(
    () => finishedAcademicPrograms.find((ap) => ap.id === academicProgramId),
    [academicProgramId, finishedAcademicPrograms],
  );

  /** Variables **/
  const isMad = selectedAP?.formative_zone === "MAD";
  const isCat = selectedAP?.formative_zone === "CAT";
  const selectedBonoName = bonosOptionsList.find((bono) => bono.key === bonoId)?.name;

  /** Lifecycles **/
  useEffect(() => {
    const fetchData = async () => {
      setSelectedExpedientAcademicProgram(await fetchExpedientAcademicProgram(studentId, academicProgramId));
      await getCertApplicationStatus(studentId, academicProgramId);
      await getAceCertApplicationStatus(studentId, academicProgramId);
      setIsLoading(false);
    };

    fetchData();
  }, [studentId]);

  useEffect(() => {
    setAaportaEmpresa(selectedAP?.company_provided);
    setBonoGenerado(selectedAP?.voucher_generated);
    setPagado(selectedAP?.paid_at);
    setCartUrl(selectedAP?.cart_url);
  }, [selectedAP]);

  /** Methods **/
  const getExpedientAcademicProgram = async (studentId, academicProgramId) => {
    setSelectedExpedientAcademicProgram(await fetchExpedientAcademicProgram(studentId, academicProgramId));
  }

  const shouldShowForm = (status) => {
    if (!status?.documents) return true;
    switch (status?.status_id) {
      case STATUS_REJECTED:
      case STAUTS_UNDEFINED:
      case undefined:
        return true;
      default:
        return false;
    }
  };

  const shouldShowRequestCard = (status) => {
    if (!status?.documents) return false;
    return true;
  };

  const handleUploadFile = (event, type) => {
    let eventFile = event.target.files[0];
    if (type === "ace") {
      setAceFile(eventFile);
      setAceFileURL(URL.createObjectURL(eventFile));
    } else {
      setFile(eventFile);
      setFileURL(URL.createObjectURL(eventFile));
    }
  };

  const handleAPSelect = async (e) => {
    const academicProgramId = +e.target.value;

    setAcademicProgramId(academicProgramId);

    formRef.current?.reset();
    handleRemoveFiles();

    setIsLoading(true);
    setSelectedExpedientAcademicProgram(await fetchExpedientAcademicProgram(studentId, academicProgramId));
    await getCertApplicationStatus(studentId, academicProgramId);
    await getAceCertApplicationStatus(studentId, academicProgramId);
    setIsLoading(false);
  };

  const handleRemoveFiles = () => {
    setFile(null);
    setFileURL("#");
    setAceFile(null);
    setAceFileURL("#");
  };

  const handleSubmitFile = async (data) => {
    setLoading(true);
    if (file) {
      setLoading(true);
      await uploadCertPaymentReceipt(
        studentId,
        file,
        academicProgramId,
        data.payed_at,
      );
      setLoading(false);
    }
    if (aceFile) {
      setLoading(true);
      await uploadAceCertPaymentReceipt(studentId, {
        file: aceFile,
        academicProgramId,
      });
      setLoading(false);
    }
    setLoading(true);
    setSelectedExpedientAcademicProgram(await fetchExpedientAcademicProgram(studentId, academicProgramId));
    await getCertApplicationStatus(studentId, academicProgramId);
    await getAceCertApplicationStatus(studentId, academicProgramId);
    setLoading(false);
    handleRemoveFiles();
    setLoading(false);
  };

  const handleOpenDownloadCertificate = async() => {
    setModalAPFinishedVisible(true)
  }

  const getCertificateApplicationHtml = () => {
    const statusId =
      certificateApplicationStatus?.documents?.length &&
      certificateApplicationStatus?.status_id;
    const aceStatusId =
      aceCertificateApplicationStatus?.documents?.length &&
      aceCertificateApplicationStatus?.status_id;
    const isPending = statusId === STATUS_PENDING_APPLICATION;
    const isRejected = statusId === STATUS_REJECTED;
    const aceIsRejected = aceStatusId === STATUS_REJECTED;
    const isValidated =
      statusId === STATUS_VALIDATED ||
      statusId === STATUS_UPLOADED_GITU ||
      statusId === STATUS_VALIDATED_INSPECTION;

    if (isRejected || (aceIsRejected && statusId !== STATUS_VALIDATED)) {
      const comments = [
        certificateApplicationStatus?.comments,
        aceCertificateApplicationStatus?.comments,
      ].filter(Boolean);

      return (
        <div
          dangerouslySetInnerHTML={{
            __html: t("cert_app_rejected").replace(
              "{{$ERROR_MESSAGE}}",
              comments.join("<br/>")
            ),
          }}
        />
      );
    }

    if (isPending) {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: t("cert_app_pending_validation"),
          }}
        />
      );
    }

    if (isValidated) {
      if (pagado) {
        return (
          <div class="mb-6">
            <span>
              {t("cert_app_payment_validated")}
            </span>
            {
              selectedExpedientAcademicProgram?.certificates[2]?.disabled === false &&
              <Fragment>
                <span>
                  {t("cert_app_payment_validated_before")}
                </span>
                <span>
                  <a
                    onClick={handleOpenDownloadCertificate}
                    className="cursor-pointer font-bold mx-1 underline"
                  >
                    {t("cert_app_payment_validated_link")}
                  </a>
                </span>
                <span>{t("cert_app_payment_validated_after")}</span>
              </Fragment>
            }
          </div>
        );
      }
      if (bonoGenerado || !aportaEmpresa) {
        return (
          <Fragment>
            {bonoGenerado && <div
              dangerouslySetInnerHTML={{
                __html: t("cert_app_voucher_registered_bono").replace(
                  "{{$CART_URL}}",
                  cartUrl
                ),
              }}
            />}
            {cartUrl ? <div
              dangerouslySetInnerHTML={{
                __html: t("cert_app_voucher_registered").replace(
                  "{{$CART_URL}}",
                  cartUrl
                ),
              }}
            /> : <div
              dangerouslySetInnerHTML={{
                __html: t("cert_app_voucher_registered_no_cart_url")
              }}
            />}
          </Fragment>
        );
      }
    } else {
      if (isCat) {
        return (
          <div
            dangerouslySetInnerHTML={{
              __html: t("cert_app_cat_application"),
            }}
          />
        );
      }
      if (isMad) {
        return (
          <div
            dangerouslySetInnerHTML={{
              __html: t("cert_app_mad_application"),
            }}
          />
        );
      }
    }

    return null;
  };

  const renderAportaEmpresa = (invalid, submitting, handleSubmit) => (
    <Fragment>
      {aportaEmpresa && !pagado && !bonoGenerado && !bonoEnviado &&
        isCertificateValidated(certificateApplicationStatus) && (
          <div className="flex flex-col gap-2">
            <p dangerouslySetInnerHTML={{ __html: t("certificate_company_benefit_intro") }} />
            <p dangerouslySetInnerHTML={{ __html: t("certificate_company_benefit_free") }} />
            <p dangerouslySetInnerHTML={{ __html: t("certificate_company_benefit_voucher") }} />
            <div className="mb-2 mt-4 font-bold">
              {t("certificate_select_voucher_type")}:
            </div>
            <div className="flex flex-col gap-4 lg:flex-row">
              <div className="w-full lg:w-9/12">
                <Select
                  noEmptyOption
                  options={bonosOptionsList}
                  value={bonoId}
                  onChange={(event) =>
                    setBonoId(event.target.value)
                  }
                  required
                />
              </div>
              <div className="w-full lg:w-3/12">
                <ButtonSpinner
                  showSpinner={loading}
                  disabled={submitting ?? submitting}
                  classNameContainer="w-full lg:w-auto"
                  className="w-full h-[48px] break-keep whitespace-nowrap lg:w-auto"
                  onClick={() => setOpenBonoConfirmModal(true)}
                >
                  {t("certificate_select_voucher")}
                </ButtonSpinner>
              </div>
            </div>
          </div>
        )}
      {!isCertificateValidated(certificateApplicationStatus) &&
        <div className="my-4 flex gap-4">
          <div className="w-full bg-white p-4">
            <h2 className="font-bold">
              {t("certificate_payment_receipt")}
            </h2>
            {shouldShowForm(certificateApplicationStatus) ? (
              <div>
                {!file ? (
                  <div className="pt-6">
                    <UploadFile
                      classNameButton="btn btn-ghost"
                      accept="application/pdf,.docx,.doc,.odt"
                      onChange={handleUploadFile}
                    >
                      {t("certificate_upload_file")}
                    </UploadFile>
                    <span className="font-color-879CA1">
                      {t("transfer_expedient_doc_types")}
                    </span>
                  </div>
                ) : (
                  <div className="m-bottom d-flex flex-column sm-no-flex-column mt-2">
                    <a
                      className="m-r font-color-149BAB m-bottom sm-no-m-bottom"
                      href={fileURL}
                      download={file.name}
                    >
                      {file.name}
                    </a>
                    <span
                      className="font-color-soft-gray t-underline cursor-pointer"
                      onClick={handleRemoveFiles}
                    >
                      {t("certificate_remove_file")}
                    </span>
                  </div>
                )}
                <form
                  id="payed-form"
                  onSubmit={handleSubmit}
                  noValidate
                >
                  <h2 className="-mb-2 mt-4 font-bold">
                    {t("certificate_payment_date")}
                  </h2>
                  <R>
                    <div className="col-100 md-col-60">
                      <FormFieldSplittedDate
                        key={academicProgramId}
                        name="payed_at"
                      />
                    </div>
                  </R>
                  <button type="submit" hidden />
                </form>
              </div>
            ) : null}
            {shouldShowRequestCard(certificateApplicationStatus) && (
              <Fragment>
                <hr className="mb-3 mt-2" />
                <h2 className="m-bottom font-bold">
                  {t("certificate_request_status")}
                </h2>
              </Fragment>
            )}

            {shouldShowRequestCard(certificateApplicationStatus) &&
              renderRequestCard(certificateApplicationStatus)}
          </div>
          <div className="w-full bg-white p-4">
            <div>
              <h2 className="font-bold">
                {t("certificate_fee_exemption_optional")}
              </h2>
              {shouldShowForm(aceCertificateApplicationStatus) ? (
                <div>
                  {!aceFile ? (
                    <div className="pt-6">
                      <UploadFile
                        classNameButton="btn btn-ghost"
                        accept="application/pdf,.docx,.doc,.odt"
                        onChange={(e) => handleUploadFile(e, "ace")}
                      >
                        {t("certificate_upload_file")}
                      </UploadFile>
                      <span className="font-color-879CA1">
                        {t("transfer_expedient_doc_types")}
                      </span>
                    </div>
                  ) : (
                    <div className="m-bottom d-flex flex-column sm-no-flex-column mt-2">
                      <a
                        className="m-r font-color-149BAB m-bottom sm-no-m-bottom"
                        href={aceFileURL}
                        download={aceFile.name}
                      >
                        {aceFile.name}
                      </a>
                      <span
                        className="font-color-soft-gray t-underline cursor-pointer"
                        onClick={handleRemoveFiles}
                      >
                        {t("certificate_remove_file")}
                      </span>
                    </div>
                  )}
                </div>
              ) : null}
            </div>
            {shouldShowRequestCard(aceCertificateApplicationStatus) && (
              <Fragment>
                <hr className="mb-3 mt-2" />
                <h2 className="m-bottom font-bold">
                  {t("certificate_request_status")}
                </h2>
              </Fragment>
            )}
            {shouldShowRequestCard(aceCertificateApplicationStatus) &&
              renderRequestCard(aceCertificateApplicationStatus)}
          </div>
        </div>}
      {!isCertificateValidated(certificateApplicationStatus) &&
        (shouldShowForm(certificateApplicationStatus) || shouldShowForm(aceCertificateApplicationStatus)) && (
          <div className="flex w-full justify-end">
            <ButtonSpinner
              showSpinner={loading}
              disabled={
                !aceFile &&
                (!file || !academicProgramId || invalid || submitting)
              }
              onClick={() =>
                file
                  ? document
                    .getElementById("payed-form")
                    ?.requestSubmit()
                  : handleSubmitFile()
              }
            >
              {t("certificate_submit_request")}
            </ButtonSpinner>
          </div>
        )}
    </Fragment>
  )

  const isCertificateValidated = (status) => {
    if (!status?.documents) return false;
    switch (status?.status_id) {
      case STATUS_VALIDATED:
      case STATUS_UPLOADED_GITU:
      case STATUS_VALIDATED_INSPECTION:
        return true;
      default:
        return false;
    }
  };

  const handleBonoSubmit = async () => {
    setOpenBonoConfirmModal(false);
    setLoading(true);
    const resp = await generateVoucher(
      selectedAP?.formative_zone,
      studentId,
      {
        academicProgramId,
        voucherType: bonoId
      }
    );
    setLoading(false);

    if (!resp.error) {
      setBonoEnviado(true);
      setOpenBonoModal(true);

      if (bonoId === 'free') {
        setBonoGenerado(true);
        setPagado(true);
      } else {
        setBonoGenerado(true);
        setCartUrl(resp?.data?.cart_url);
      }
    }
  };

  const renderRequestCard = (request) => (
    <Card smOnly={false}>
      <p className="mb-1 font-bold">{request.academic_program_name}</p>
      <BadgeComponent status={request?.status_id} />
    </Card>
  );

  const renderSpinner = () => (
    <div className="flex justify-center my-6">
      <div className="relative h-6">
        <Spinner className="w-6 h-6" />
      </div>
      <p className="pl-10 pt-0 text-center">{t("certificate_loading_data")}</p>
    </div>
  );

  const onFinishedModalFinishedAPCertificate = async () => {
    setIsLoading(true);
    setModalAPFinishedVisible(false);
    try {
      await getExpedientAcademicProgram(studentId, academicProgramId);
    } finally {
      setIsLoading(false);
    }
  };

  const renderBonoModalContent = () => {
    let html;

    if (bonoId === "free") {
      html = (
        <div
          dangerouslySetInnerHTML={{
            __html: t("cert_app_free_voucher_modal"),
          }}
        />
      );
    }

    if (bonoId === "general_voucher") {
      html = (
        <div
          dangerouslySetInnerHTML={{
            __html: t("cert_app_general_voucher_modal").replace(
              "{{$CART_URL}}",
              cartUrl
            ),
          }}
        />
      );
    }

    if (bonoId === "new_student_voucher") {
      html = (
        <div
          dangerouslySetInnerHTML={{
            __html: t("cert_app_friend_voucher_modal").replace(
              "{{$CART_URL}}",
              cartUrl
            ),
          }}
        />
      );
    }

    return (
      <Fragment>
        {html}
        <div className="flex">
          <a class="btn modal-close ml-auto mt-2 bg-neutral-100 hover:bg-neutral-200" onClick={() => setOpenBonoModal(false)}>
            {t("certificate_modal_close")}
          </a>
        </div>
      </Fragment>
    )
  }

  /** Render **/
  return (
    <Fragment>
      <CF className="max-width-980 m-x2-top">
        {showMultipleCicles && (
          <div className="mb-4">
            <div className="font-bold">{t("certificate_select_cycle")}:</div>
            <Select
              noEmptyOption
              options={academicPrograms}
              value={academicProgramId}
              onChange={handleAPSelect}
              required
            />
          </div>
        )}
        <FinalForm
          onSubmit={handleSubmitFile}
          initialValues={{ payed_at: null }}
          validate={(values) => {
            const errors = {};
            if (!values.payed_at) {
              errors.payed_at = t("certificate_required_field");
            }
            return errors;
          }}
          render={({ handleSubmit, form }) => {
            formRef.current = form;
            const { invalid, submitting } = form.getState();
            return (
              <Fragment>
                {isLoading ? renderSpinner() : getCertificateApplicationHtml()}
                {!isLoading && renderAportaEmpresa(invalid, submitting, handleSubmit)}
                {!isLoading && pagado && <Fragment>
                  <div dangerouslySetInnerHTML={{
                    __html: t("certificate_title_processing_reminder").replace("{{$FORMATIVE_ZONE}}",
                      isMad ? t('certificate_title_processing_reminder_mad') : t('certificate_title_processing_reminder_cat'))
                  }} /><br />
                  <div dangerouslySetInnerHTML={{
                    __html: t("certificate_contact_phone")
                  }} />
                </Fragment>}
              </Fragment>
            );
          }}
        />
      </CF>
      <Modal
        bodyClass="mx-4 max-w-[800px]"
        title={t("certificate_fee_exemptions_title")}
        visible={openBonoModal}
      >
        <div className="p-8">
          {renderBonoModalContent()}
        </div>
      </Modal>
      <Modal
        bodyClass="mx-4 max-w-[800px]"
        closeModal={() => setOpenBonoConfirmModal(false)}
        visible={openBonoConfirmModal}
      >
        <div className="flex flex-col">
          <div className="flex items-center justify-between border-b border-neutral-200 px-8 py-6">
            <p className="t-left font-24 line-height-24 no-margin font-bold">
              {t("Confirma tu solicitud")}
            </p>
            <a
              className="modal-close-jobs modal-link"
              onClick={() => setOpenBonoConfirmModal(false)}
            >
              <i className="fal fa-times font-20" />
            </a>
          </div>
          <div className="px-8 py-6">
            <p className="font-18 no-margin">
              {t("certificate_selected_voucher_confirmation")}
              <strong>{selectedBonoName}</strong>.
              {t("certificate_selected_voucher_warning")}
            </p>
          </div>
          <div className="flex flex-col gap-4 px-8 pb-6 sm:flex-row sm:justify-end">
            <ButtonGhost
              className="flex h-[48px] w-full items-center justify-center whitespace-nowrap break-keep lg:w-auto"
              onClick={() => setOpenBonoConfirmModal(false)}
            >
              {t("Cancelar")}
            </ButtonGhost>
            <ButtonPrimary
              className="flex h-[48px] w-full items-center justify-center whitespace-nowrap break-keep lg:w-auto"
              disabled={loading}
              onClick={handleBonoSubmit}
            >
              {t("Confirmar solicitud")}
            </ButtonPrimary>
          </div>
        </div>
      </Modal>
      {modalAPFinishedVisible && 
        <ModalFinishedAPCertificate academicProgram={selectedExpedientAcademicProgram}
            visible={modalAPFinishedVisible}
            closeModal={() => setModalAPFinishedVisible(false)}
            onFinished={onFinishedModalFinishedAPCertificate}
        />
      }
    </Fragment>
  );
}

CertificateApplication = connect(
  ({ auth, certificateApplication, status }) => {
    return {
      studentId: auth.loggedUser.id,
      certificateApplicationStatus: certificateApplication?.status,
      aceCertificateApplicationStatus: certificateApplication?.aceStatus,
      finishedAcademicPrograms: status.student_meta.finished_academic_programs,
    };
  },
  {
    fetchExpedientAcademicProgram,
    getCertApplicationStatus,
    getAceCertApplicationStatus,
    uploadCertPaymentReceipt,
    uploadAceCertPaymentReceipt,
    generateVoucher,
  },
)(CertificateApplication);

export default () => {
  const history = useHistory();
  return (
    <AppPage
      name="certificate-application"
      title={t("certificate_application_title")}
      back={history.goBack}
      class="max-width-980"
    >
      <CertificateApplication />
    </AppPage>
  );
};
